import axios from "axios"

export default class GiftBox {
  constructor() {
    this.cartForm = document.querySelector("#cart")
    this.giftBoxElement = document.querySelector("#add-gift-box")

    this.giftBoxElement.addEventListener("change", this.handleChange.bind(this))
  }

  handleChange(event) {
    const checked = event.target.checked

    let giftBoxPayload = {
      attributes: {
        "gift-box": (checked ? true : "")
      },
      updates: {
        39339774804054: (checked ? 1 : 0)
      }
    }

    this.updateGiftBoxStatus(giftBoxPayload)
  }

  updateGiftBoxStatus(payload) {
    axios.post("/cart/update.js", payload).then((response) => {
      this.updateCart()
    }).catch((error) => {
      console.log("error", error)
    })
  }

  updateCart() {
    this.cartForm.submit()
  }
}
